import BasePage from "@Scripts/Pages/BasePage";

export default class GoogleMaps extends BasePage {
    public static async init() {
        await super.init();

        await this.loadScript();
    }

    private static async loadScript() {
        let googleMapScript = document.createElement("script");
        googleMapScript.setAttribute("id", "GoogleMapScript");
        googleMapScript.setAttribute('async', '');
        googleMapScript.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=AIzaSyB8rPocMOc2Y0UpDJjvrA3pxykLMpAruX4&language=it");
        document.head.appendChild(googleMapScript);

        googleMapScript.addEventListener("load", function () {
            GoogleMaps.setGoogleMaps();
        });
    }

    private static setGoogleMaps() {
        let googleMaps,
            infowindow,
            initZoom = 2,
            icoSizeWidth = 33,
            icoSizeHeight = 39,
            initLatitude = (<any>document.querySelector("input[name = \"InitLatitude\"]")).value,
            initLongitude = (<any>document.querySelector("input[name = \"InitLongitude\"]")).value,
            isMapTypeControl = false,
            isZoomControl = true,
            isStreetViewControl = false,
            isScrollWheel = true,
            isKeyboardShortcuts = true,
            isPanControl = false,
            isDisableDoubleClickZoom = false,
            styles = [{
                featureType: "all",
                elementType: "all",
                stylers: [
                    { saturation: -50 }
                ]
            }];

        setGoogleMarkers();

        function initialize() {
            var mapOptions = {
                zoom: initZoom,
                center: new (<any>window).google.maps.LatLng(initLatitude, initLongitude),
                //mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControlOptions: {
                    mapTypeIds: [(<any>window).google.maps.MapTypeId.ROADMAP, "styles"]
                },
                mapTypeControl: isMapTypeControl,
                zoomControl: isZoomControl,
                streetViewControl: isStreetViewControl,
                scrollwheel: isScrollWheel,
                disableDoubleClickZoom: isDisableDoubleClickZoom,
                keyboardShortcuts: isKeyboardShortcuts,
                panControl: isPanControl
            };

            googleMaps = new (<any>window).google.maps.Map(document.getElementById("GoogleMaps"), mapOptions);

            googleMaps.mapTypes.set("styles", new (<any>window).google.maps.StyledMapType(styles, { name: "Styles" }));
            googleMaps.setMapTypeId("styles");

            document.querySelectorAll(".google-maps-marker").forEach(element => {
                let markerIcon = (<any>element.querySelector("input[name = \"MarkerIcon\"]")).value;
                let markerLatitude = (<any>element.querySelector("input[name = \"Latitude\"]")).value;
                let markerLongitude = (<any>element.querySelector("input[name = \"Longitude\"]")).value;
                let markerTitle = (<any>element.querySelector("input[name = \"MarkerTitle\"]")).value;
                let markerContents = (<any>element.querySelector(".infowindow")).innerHTML;

                if (!markerIcon) {
                    markerIcon = "google-maps-marker@2x.png";
                }

                var latlng = new (<any>window).google.maps.LatLng(markerLatitude, markerLongitude);
                googleMaps.addMarker(createMarker(markerTitle, markerIcon, markerContents, latlng));
            });

            function createMarker(name, icon, contents, latlng) {
                var marker = new (<any>window).google.maps.Marker({
                    title: name,
                    position: latlng,
                    map: googleMaps,
                    icon: new (<any>window).google.maps.MarkerImage("/images/" + icon, null, null, null, new (<any>window).google.maps.Size(icoSizeWidth, icoSizeHeight))
                });

                (<any>window).google.maps.event.addListener(marker, "click", function () {
                    if (infowindow) {
                        infowindow.close();
                    }
                    infowindow = new (<any>window).google.maps.InfoWindow({ content: contents });
                    infowindow.open(googleMaps, marker);
                });

                (<any>window).google.maps.event.addListener(googleMaps, "click", function () {
                    if (infowindow) {
                        infowindow.close();
                    }
                });

                return marker;
            }
        }

        function resizeMap() {
            console.log("resize");
            var center = googleMaps.getCenter();
            (<any>window).google.maps.event.trigger(googleMaps, "resize");
            googleMaps.setCenter(center);
        }

        function setGoogleMarkers() {
            (<any>window).google.maps.Map.prototype.markers = new Array();

            (<any>window).google.maps.Map.prototype.addMarker = function (marker) {
                this.markers[this.markers.length] = marker;
            };

            (<any>window).google.maps.Map.prototype.getMarkers = function () {
                return this.markers
            };

            (<any>window).google.maps.Map.prototype.clearMarkers = function () {
                if (infowindow) {
                    infowindow.close();
                }

                for (var i = 0; i < this.markers.length; i++) {
                    this.markers[i].set_map(null);
                }
            };
        }

        //: Carica la mappa
        initialize();
        window.addEventListener('resize', resizeMap);
    };
}